module.exports = __webpack_public_path__ + "static/media/bonusSpins_5_7.688c56a3.png";